import { render, staticRenderFns } from "./selectAdd.vue?vue&type=template&id=174604ea&"
import script from "./selectAdd.vue?vue&type=script&lang=js&"
export * from "./selectAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports